<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="编号名称" prop="name" :error="formErrorMsg.name">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>

            <el-form-item label="编号标识" prop="flag" :error="formErrorMsg.flag">
                <el-input v-model="formData.flag"></el-input>
            </el-form-item>

            <el-form-item label="前缀" prop="prefix" :error="formErrorMsg.prefix">
                <el-input v-model="formData.prefix"></el-input>
            </el-form-item>


            <el-form-item label="生成规则" prop="genRule" :error="formErrorMsg.genRule">
                <el-input v-model="formData.genRule"></el-input>
            </el-form-item>


            <el-form-item label="重置周期" prop="resetCycle" :error="formErrorMsg.resetCycle">
                <dict-select type-flag="BUS_NUM_REST_CYCLE" v-model="formData.resetCycle"></dict-select>
            </el-form-item>


            <el-form-item label="序号长度" prop="length" :error="formErrorMsg.length">
                <el-input v-model="formData.length"></el-input>
            </el-form-item>


            <el-form-item label="初始序号" prop="initNum" :error="formErrorMsg.initNum">
                <el-input-number v-model="formData.initNum" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="当前序号" prop="incNum" :error="formErrorMsg.incNum">
                <el-input-number v-model="formData.incNum" :min="0"></el-input-number>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>
    import ModuleCascader from "../../components/ModuleCascader";
    import DictSelect from "../../components/DictSelect";

    export default {
        name: "RuleEdit",
        components: {DictSelect, ModuleCascader},
        data() {
            return {
                api: {
                    update: this.$api.busNumRule.update,
                    detail: this.$api.busNumRule.detail,
                },
                formErrorMsg: {
                    genRule: '',
                    initNum: '',
                    incNum: '',
                    length: '',
                    prefix: '',
                    resetCycle: '',
                    name: '',
                    flag: '',
                },
                formData: {
                    code: '',
                    genRule: '',
                    initNum: '',
                    incNum: '',
                    length: '',
                    prefix: '',
                    resetCycle: '',
                    name: '',
                    flag: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入编号名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入编号标识', trigger: 'blur'},
                    ],
                    genRule: [
                        {required: true, message: '请输入编号规则', trigger: 'blur'},
                    ],
                    length: [
                        {required: true, message: '请输入序号长度', trigger: 'blur'},
                    ],

                    initNum: [
                        {required: true, message: '请输入初始序号', trigger: 'blur'},
                    ]
                    ,

                    resetCycle: [
                        {required: true, message: '请选择重置周期', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update, vm.$qs.stringify(this.formData)).then((resp) => {

                            if (resp.data.status === 200) {
                                vm.$message({
                                    type: 'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            } else if (resp.data.status === 400) {
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });
                                vm.$message({
                                    type: "error",
                                    message: resp.data.desc
                                });
                            } else {
                                vm.$message({
                                    type: "error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (resp) {
                for (let key in resp.data.data) {
                    for (let fKey in vm.formData) {
                        vm.formData[fKey] = resp.data.data[key][fKey]

                        if (fKey === 'birthday' && vm.formData[fKey]) {
                            vm.formData['birthday'] = vm.$moment(vm.formData[fKey]).format('YYYY-MM-DD');
                        }

                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>